import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_courtdepartment = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DEPARTMENT}/`);
};
export const dispute_resolution_getbyid_courtdepartment = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DEPARTMENT}/by-id/${id}`);
};
export const dispute_resolution_add_courtdepartment = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_DEPARTMENT}/`, data);
};
export const dispute_resolution_update_courtdepartment = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_DEPARTMENT}/${id}`, data);
};
export const dispute_resolution_delete_courtdepartment = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_DEPARTMENT}/${id}`);
};
